import { useEffect, useState } from 'react';
import { AdminPanelDrawerContext } from './AdminPanelDrawerContext';

export const AdminPanelDrawerProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [isFormClean, setIsFormClean] = useState(true);
  const [triggerClose, setTriggerClose] = useState(false);
  const [triggerTabChange, setTriggerTabChange] = useState(false);
  const [tabIndex, setTabIndex] = useState('1');
  const [tabIndexToMove, setTabIndexToMove] = useState('1');

  const handleCloseTrigger = () => {
    setTriggerClose(true);
  };

  const handleTriggerChangeTab = (
    event: React.SyntheticEvent,
    newValue: string,
  ) => {
    setTabIndexToMove(newValue);
    setTriggerTabChange(true);
  };

  const handleClear = () => {
    setTriggerClose(false);
    setTabIndex('1');
    setTabIndexToMove('1');
  };

  const handleCloseConfirmationModal = () => {
    setTriggerClose(false);
    setTriggerTabChange(false);
  };

  useEffect(() => {
    if (triggerTabChange && isFormClean) {
      setTabIndex(tabIndexToMove);
      setTriggerTabChange(false);
    }
  }, [triggerTabChange, isFormClean]);

  return (
    <AdminPanelDrawerContext.Provider
      value={{
        isFormClean,
        setIsFormClean,
        triggerClose,
        triggerTabChange,
        handleCloseConfirmationModal,
        handleCloseTrigger,
        tabIndex,
        handleTriggerChangeTab,
        handleClear,
      }}
    >
      {children}
    </AdminPanelDrawerContext.Provider>
  );
};
